import type { PlayerId } from "@cloudnest/warchest-engine";

/** Korean display names for unit IDs (UI layer only — engine unchanged). */
export const WC_UNIT_NAME: Readonly<Record<string, string>> = {
  SWORDSMAN: "검사",
  PIKEMAN: "창병",
  CROSSBOWMAN: "석궁병",
  LIGHT_CAVALRY: "경기병",
  ARCHER: "궁수",
  CAVALRY: "기병",
  LANCER: "창기병",
  SCOUT: "정찰병",
  BERSERKER: "광전사",
  ENSIGN: "기수",
  FOOTMAN: "보병",
  KNIGHT: "기사",
  MARSHALL: "원수",
  MERCENARY: "용병",
  ROYAL_GUARD: "근위병",
  WARRIOR_PRIEST: "전사 사제",
  ROYAL: "로열",
};

/** Korean ability text for unit IDs. */
export const WC_UNIT_ABILITY: Readonly<Record<string, string>> = {
  ARCHER: "2칸 떨어진 적을 공격합니다.",
  BERSERKER: "이동 후, 쌓인 코인을 제거해 연속 이동합니다.",
  CAVALRY: "한 행동으로 이동 후 공격합니다.",
  CROSSBOWMAN: "2칸 원거리 공격, 경로가 비어 있어야 합니다.",
  ENSIGN: "인접한 아군 유닛에게 무료 이동을 줍니다.",
  FOOTMAN: "두 보병이 함께 기동하며, 동시에 둘을 배치할 수 있습니다.",
  KNIGHT: "강화된 유닛만 이 유닛을 공격할 수 있습니다.",
  LANCER: "직선으로 1–2칸 이동 후 공격합니다. 일반 공격은 없습니다.",
  LIGHT_CAVALRY: "정확히 2칸 이동합니다.",
  MARSHALL: "인접한 아군에게 일반 공격을 부여합니다.",
  MERCENARY: "배치된 상태에서 모집되면 무료 기동을 합니다.",
  PIKEMAN: "이 유닛을 공격하면 공격자가 코인을 잃습니다.",
  ROYAL_GUARD: "로열 코인을 버려 점령한 위치로 이동합니다.",
  SCOUT: "위치뿐 아니라 아군 유닛 옆에도 배치됩니다.",
  SWORDSMAN: "공격 후 이동합니다.",
  WARRIOR_PRIEST: "공격하거나 점령한 후 코인을 뽑습니다.",
};

/** Korean faction names (Raven → 까마귀, Wolf → 늑대). */
export const WC_FACTION_NAME: Readonly<Record<PlayerId, string>> = {
  P1: "까마귀",
  P2: "늑대",
};
